/**
 * Collapse long breadcrumb label lists for narrow list meta lines.
 * Keeps the first segment (usually workspace) and the last folder; middle becomes "…".
 * Full path belongs in a title/tooltip.
 */
export function collapseBreadcrumbLabels(
  labels: string[],
  opts?: { sep?: string },
): string {
  const sep = opts?.sep ?? ' / '
  const parts = labels.map((l) => l.trim()).filter(Boolean)
  if (parts.length <= 2) return parts.join(sep)
  return `${parts[0]}${sep}…${sep}${parts[parts.length - 1]}`
}
